(() => {
  const normalize = (value = '') => String(value)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

  const formatCLP = (minorUnits) => new Intl.NumberFormat('es-CL', {
    style: 'currency',
    currency: 'CLP',
    maximumFractionDigits: 0
  }).format(Number(minorUnits || 0) / 100);

  const budgetRanges = {
    under25: [0, 2500000],
    '25to50': [2500001, 5000000],
    '50to80': [5000001, 8000000],
    over80: [8000001, Number.POSITIVE_INFINITY]
  };

  const groupPreferences = {
    vulva: ['succionadores-intimos', 'vibradores-intimos', 'cuidado-intimo'],
    pene: ['masturbadores-masculinos', 'plugs-anales', 'en-pareja'],
    pareja: ['en-pareja', 'juegos-para-parejas', 'lubricantes-intimos'],
    bienestar: ['cuidado-intimo', 'lubricantes-intimos', 'destacados']
  };

  const sensationPreferences = {
    succion: { groups: ['succionadores-intimos'], words: ['succion', 'presion', 'sonico', 'sona'] },
    vibracion: { groups: ['vibradores-intimos'], words: ['vibrador', 'vibracion', 'rabbit', 'masajeador'] },
    presion: { groups: ['masturbadores-masculinos'], words: ['presion', 'masturbador', 'men ', 'huevo'] },
    juego: { groups: ['juegos-para-parejas', 'en-pareja'], words: ['pareja', 'juego', 'cartas', 'dados', 'ruleta', 'anillo'] },
    cuidado: { groups: ['cuidado-intimo', 'lubricantes-intimos'], words: ['cuidado', 'lubricante', 'kegel', 'copa', 'suelo pelvico'] }
  };

  const buildCatalog = (items) => {
    const byHandle = new Map();
    items.forEach((item) => {
      if (!item || !item.handle) return;
      const existing = byHandle.get(item.handle);
      if (existing) {
        if (!existing.groups.includes(item.group)) existing.groups.push(item.group);
        return;
      }
      const tags = Array.isArray(item.tags) ? item.tags : [];
      byHandle.set(item.handle, {
        ...item,
        groups: [item.group],
        searchText: normalize([item.title, item.vendor, ...tags].join(' '))
      });
    });
    return Array.from(byHandle.values()).filter((item) => item.available !== false);
  };

  const scoreProduct = (product, answers) => {
    let score = product.groups.includes('destacados') ? 1 : 0;
    const desiredGroups = groupPreferences[answers.goal] || [];
    product.groups.forEach((group) => {
      if (desiredGroups.includes(group)) score += 12;
    });

    const sensation = sensationPreferences[answers.sensation];
    if (sensation) {
      product.groups.forEach((group) => {
        if (sensation.groups.includes(group)) score += 10;
      });
      sensation.words.forEach((word) => {
        if (product.searchText.includes(normalize(word))) score += 3;
      });
    }

    if (answers.experience === 'first') {
      if (product.searchText.includes('principiante') || product.searchText.includes('compact') || product.searchText.includes('mini')) score += 6;
      if (Number(product.price) <= 6000000) score += 3;
      if (product.searchText.includes('app') || product.searchText.includes('bluetooth')) score -= 1;
    } else if (answers.experience === 'experienced') {
      ['app', 'bluetooth', 'multifuncion', 'doble', 'calor', 'wave', 'pro', 'premium'].forEach((word) => {
        if (product.searchText.includes(word)) score += 2;
      });
    } else {
      score += 1;
    }

    if (answers.intensity === 'soft') {
      ['mini', 'compact', 'principiante', 'suave'].forEach((word) => {
        if (product.searchText.includes(word)) score += 2;
      });
    }
    if (answers.intensity === 'intense') {
      ['power', 'pro', 'wave', 'doble', 'rabbit', 'triple', 'master'].forEach((word) => {
        if (product.searchText.includes(word)) score += 2;
      });
    }
    if (answers.intensity === 'varied') {
      ['niveles', 'intensidades', 'modos', 'patrones', 'app', 'bluetooth'].forEach((word) => {
        if (product.searchText.includes(word)) score += 2;
      });
    }

    const hasApp = ['app', 'bluetooth', 'lovense', 'control remoto', 'control por'].some((word) => product.searchText.includes(word));
    if (answers.control === 'app' && hasApp) score += 9;
    if (answers.control === 'remote' && (hasApp || product.groups.includes('en-pareja'))) score += 8;
    if (answers.control === 'simple' && !hasApp) score += 4;

    if (answers.context === 'partner' && (product.groups.includes('en-pareja') || product.groups.includes('juegos-para-parejas'))) score += 10;
    if (answers.context === 'solo' && !product.groups.includes('juegos-para-parejas')) score += 3;
    if (answers.context === 'both' && (product.groups.includes('destacados') || product.groups.includes('en-pareja'))) score += 5;

    const range = budgetRanges[answers.budget];
    const price = Number(product.price || 0);
    if (range) {
      if (price >= range[0] && price <= range[1]) score += 12;
      else if (price < range[0]) score += 2;
      else score -= Math.min(5, Math.ceil((price - range[1]) / 2000000));
    }

    return score;
  };

  const createProductCard = (product, index) => {
    const article = document.createElement('article');
    article.className = 'clio-quiz-product';

    const media = document.createElement('a');
    media.className = 'clio-quiz-product__media';
    media.href = product.url;

    const badge = document.createElement('span');
    badge.className = 'clio-quiz-product__badge';
    badge.textContent = index === 0 ? 'Mejor coincidencia' : `Opción ${index + 1}`;
    media.appendChild(badge);

    if (product.image) {
      const image = document.createElement('img');
      image.src = product.image;
      image.alt = product.imageAlt || product.title;
      image.loading = 'lazy';
      image.width = 720;
      image.height = 720;
      media.appendChild(image);
    } else {
      const placeholder = document.createElement('span');
      placeholder.className = 'clio-quiz-product__placeholder';
      placeholder.textContent = 'CLIO';
      media.appendChild(placeholder);
    }

    const body = document.createElement('div');
    body.className = 'clio-quiz-product__body';

    const vendor = document.createElement('span');
    vendor.className = 'clio-quiz-product__vendor';
    vendor.textContent = product.vendor || 'CLIO';

    const title = document.createElement('h3');
    title.className = 'clio-quiz-product__title';
    title.textContent = product.title;

    const price = document.createElement('div');
    price.className = 'clio-quiz-product__price';
    price.textContent = formatCLP(product.price);

    const link = document.createElement('a');
    link.className = 'button';
    link.href = product.url;
    link.textContent = 'Ver producto';

    body.append(vendor, title, price, link);
    article.append(media, body);
    return article;
  };

  const initQuiz = (root) => {
    const form = root.querySelector('[data-quiz-form]');
    const steps = Array.from(root.querySelectorAll('[data-step]'));
    const back = root.querySelector('[data-quiz-back]');
    const forward = root.querySelector('[data-quiz-forward]');
    const error = root.querySelector('[data-step-error]');
    const results = root.querySelector('[data-quiz-results]');
    const resultHeading = results?.querySelector('h2');
    const productsContainer = root.querySelector('[data-product-results]');
    const restart = root.querySelector('[data-quiz-restart]');
    const progressLabel = root.querySelector('[data-progress-label]');
    const progressPercent = root.querySelector('[data-progress-percent]');
    const progressFill = root.querySelector('[data-progress-fill]');
    const summary = root.querySelector('[data-result-summary]');
    const progress = root.querySelector('.clio-quiz__progress');
    const dataElement = document.getElementById('ClioQuizProducts');
    if (!form || !steps.length || !dataElement) return;

    let rawProducts = [];
    try { rawProducts = JSON.parse(dataElement.textContent || '[]'); } catch (errorParsing) { rawProducts = []; }
    const catalog = buildCatalog(rawProducts);
    let current = 0;

    const updateStep = ({ focus = false } = {}) => {
      steps.forEach((step, index) => { step.hidden = index !== current; });
      const percent = Math.round(((current + 1) / steps.length) * 100);
      progressLabel.textContent = `Pregunta ${current + 1} de ${steps.length}`;
      progressPercent.textContent = `${percent}%`;
      progressFill.style.width = `${percent}%`;
      back.hidden = current === 0;
      forward.hidden = current >= steps.length - 1 || !currentHasAnswer();
      error.hidden = true;
      const legend = steps[current].querySelector('legend');
      if (legend && focus) {
        legend.tabIndex = -1;
        requestAnimationFrame(() => legend.focus({ preventScroll: true }));
      }
    };

    const currentHasAnswer = () => Boolean(steps[current].querySelector('input[type="radio"]:checked'));

    const collectAnswers = () => Object.fromEntries(new FormData(form).entries());

    const renderResults = () => {
      const answers = collectAnswers();
      const ranked = catalog
        .map((product) => ({ product, score: scoreProduct(product, answers) }))
        .sort((a, b) => b.score - a.score || a.product.handle.localeCompare(b.product.handle));

      let recommended = ranked.slice(0, 3).map((entry) => entry.product);
      if (recommended.length < 3) {
        catalog.forEach((product) => {
          if (recommended.length < 3 && !recommended.some((item) => item.handle === product.handle)) recommended.push(product);
        });
      }

      productsContainer.replaceChildren();
      recommended.forEach((product, index) => productsContainer.appendChild(createProductCard(product, index)));

      const goalLabel = form.querySelector(`input[name="goal"][value="${answers.goal}"]`)?.closest('label')?.querySelector('strong')?.textContent;
      const budgetLabel = form.querySelector(`input[name="budget"][value="${answers.budget}"]`)?.closest('label')?.querySelector('strong')?.textContent;
      summary.textContent = goalLabel && budgetLabel
        ? `Priorizamos ${goalLabel.toLowerCase()} y un presupuesto de ${budgetLabel.toLowerCase()}. Puedes abrir cada ficha para revisar materiales, funciones y cuidados.`
        : 'Comparamos tus respuestas con los productos disponibles en CLIO.';

      form.hidden = true;
      progress.hidden = true;
      results.hidden = false;
      if (resultHeading) {
        resultHeading.tabIndex = -1;
        requestAnimationFrame(() => resultHeading.focus({ preventScroll: true }));
      }
      results.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    back.addEventListener('click', () => {
      current = Math.max(current - 1, 0);
      updateStep({ focus: true });
    });

    forward.addEventListener('click', () => {
      if (!currentHasAnswer() || current >= steps.length - 1) return;
      current += 1;
      updateStep({ focus: true });
    });

    form.addEventListener('change', (event) => {
      error.hidden = true;
      if (!event.target.matches('input[type="radio"]')) return;
      if (current < steps.length - 1) {
        current += 1;
        updateStep({ focus: true });
        return;
      }
      renderResults();
    });
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      if (!currentHasAnswer()) { error.hidden = false; return; }
      renderResults();
    });

    restart.addEventListener('click', () => {
      form.reset();
      current = 0;
      results.hidden = true;
      form.hidden = false;
      progress.hidden = false;
      productsContainer.replaceChildren();
      updateStep({ focus: true });
      root.querySelector('.clio-quiz__panel')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    updateStep();
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-clio-quiz]').forEach(initQuiz);
  });
})();
